import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "elemental-resonance" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "members" }
const _hoisted_6 = {
  key: 0,
  class: "res"
}
const _hoisted_7 = {
  key: 1,
  class: "team-tags"
}
const _hoisted_8 = { style: {"text-align":"left"} }
const _hoisted_9 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MemberItem = _resolveComponent("MemberItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('team' + _ctx.selectedClass)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "handle" }, "◆", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.team.name), 1),
        (_ctx.editable && _ctx.selected)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "button material-symbols-outlined",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editOnClick && _ctx.editOnClick(...args)))
            }, " edit_square "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (_ctx.resonanceElementImgSrcs[index])
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "elemental-resonance",
                  src: _ctx.resonanceElementImgSrcs[index],
                  alt: "resonance"
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ], 64))
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", null, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.members, (member) => {
              return (_openBlock(), _createElementBlock("td", {
                key: member.id
              }, [
                _createVNode(_component_MemberItem, {
                  member: member,
                  statsObj: _ctx.memberStats[member.id],
                  displayStat: _ctx.displayStat,
                  showEquipment: _ctx.showEquipment,
                  viewable: true,
                  members: _ctx.team.members.map(s => s.name),
                  elementalResonance: _ctx.elementalResonance
                }, null, 8, ["member", "statsObj", "displayStat", "showEquipment", "members", "elementalResonance"])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    (_ctx.displayRes)
      ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resKey, (key) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: key,
                  class: _normalizeClass(_ctx.resBgClass(key))
                }, _toDisplayString(_ctx.res[key]), 3))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.displayTags)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.tags, (tag) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "tag",
              key: tag
            }, _toDisplayString(tag), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", {
        class: "material-symbols-outlined control-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.jumpToRotation && _ctx.jumpToRotation(...args)))
      }, "stat_minus_2"),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.description), 1)
    ])
  ], 2))
}